export default __webpack_public_path__ + "static/media/hero.a79f10ea.jpg";